// extracted by mini-css-extract-plugin
export default {"tableRow":"styles_tableRow__F-BPf","price":"styles_price__KVwSA"};